export default function getOptionsWithRemovedIndex(
  currentOptions: Record<string, unknown>[],
  index: number,
) {
  return currentOptions.filter((_, i) => i !== index);
}
